<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Ruta' : 'Crear Nueva Ruta' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <form [formGroup]="routeForm" (ngSubmit)="onSubmit()">
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Nombre de la Ruta</mat-label>
            <input matInput formControlName="name" placeholder="Ej: Belén - Zona 1" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="nameControl?.invalid && (nameControl?.dirty || nameControl?.touched)">
                <span *ngIf="nameControl?.errors?.['required']">El nombre de la ruta es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-slide-toggle formControlName="status" class="mb-4">
            Activo
        </mat-slide-toggle>
        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>
    </form>
</mat-dialog-content>